// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyra-drawer .gyra-drawer-body {
  padding: 2rem 5rem;
  padding-right: 0rem;
  height: 100%;
  overflow-y: hidden;
}
.gyra-drawer .gyra-drawer-body .close-button .close-icon {
  margin-right: 0.5rem;
}
@media (max-width: 768px) {
  .gyra-drawer .gyra-drawer-body {
    padding: 1rem;
    padding-right: 0rem;
  }
}
.gyra-drawer .gyra-drawer-content {
  height: 100%;
  padding-right: 5rem;
  padding-bottom: 8.75rem;
  overflow-y: auto;
  overflow-x: hidden;
}
.gyra-drawer .gyra-drawer-content.no-footer {
  padding-bottom: 2.5rem;
}
@media (max-width: 768px) {
  .gyra-drawer .gyra-drawer-content {
    padding-right: 1rem;
  }
}
.gyra-drawer .gyra-drawer-content .divider,
.gyra-drawer .gyra-drawer-content hr {
  opacity: 1;
  border-top: 0.063rem solid #c9d3cc;
  margin-top: calc(3.5rem - 2rem);
}
.gyra-drawer .gyra-drawer-content .divider:not(.success-divider),
.gyra-drawer .gyra-drawer-content hr:not(.success-divider) {
  margin-bottom: 3.5rem;
}
@media (max-width: 768px) {
  .gyra-drawer .gyra-drawer-content .divider:not(.success-divider),
  .gyra-drawer .gyra-drawer-content hr:not(.success-divider) {
    margin-bottom: 1.5rem;
  }
}
@media (max-width: 768px) {
  .gyra-drawer .gyra-drawer-content .divider,
  .gyra-drawer .gyra-drawer-content hr {
    margin: 0rem 0rem 1.5rem 0rem;
  }
}
.gyra-drawer .gyra-drawer-content .ant-form-item {
  margin-bottom: 2rem;
}
@media (max-width: 768px) {
  .gyra-drawer .gyra-drawer-content .ant-form-item {
    margin-bottom: 1.5rem;
  }
}
.gyra-drawer .gyra-drawer-content .gyramais-alert {
  margin-bottom: 2rem;
}
.gyra-drawer .gyra-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  border-top: 0.063rem solid #00000025;
  justify-content: space-between;
  padding: 1.25rem 3.5rem;
  opacity: 1;
  z-index: 3;
  background-color: #ffffff;
}
.gyra-drawer .gyra-drawer-footer.no-back-btn {
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .gyra-drawer .gyra-drawer-footer {
    z-index: 1;
    padding: 1rem;
    justify-content: space-between;
  }
  .gyra-drawer .gyra-drawer-footer.no-back-btn {
    justify-content: center;
  }
  .gyra-drawer .gyra-drawer-footer.no-back-btn .gyramais-btn {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .gyra-drawer .gyra-drawer-footer {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .gyra-drawer .gyra-drawer-footer:not(.no-back-btn) .gyramais-btn {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .gyra-drawer .gyra-drawer-footer:not(.no-back-btn) .gyramais-btn.back-button {
    padding-left: 0;
    padding-right: 0;
  }
  .gyra-drawer .gyra-drawer-footer .gyramais-btn-link {
    padding-left: 0rem;
    width: fit-content !important;
  }
}
.gyra-drawer .gyra-drawer-title {
  padding: 2.5rem 0rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/gyramais/Drawer/styles.less"],"names":[],"mappings":"AAAA;EAEI,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAAJ;AALA;EASQ,oBAAA;AADR;AAKI;EAAA;IACE,aAAA;IACA,mBAAA;EAFJ;AACF;AAdA;EAoBI,YAAA;EACA,mBAAA;EACA,uBAAA;EAMA,gBAAA;EACA,kBAAA;AARJ;AAGI;EACE,sBAAA;AADN;AAOI;EAAA;IACE,mBAAA;EAJJ;AACF;AA7BA;;EAqCM,UAAA;EACA,kCAAA;EACA,+BAAA;AAJN;AAMM;;EACE,qBAAA;AAHR;AAKQ;EAAA;;IACE,qBAAA;EADR;AACF;AAIM;EAAA;;IACE,6BAAA;EAAN;AACF;AAnDA;EAuDM,mBAAA;AADN;AAGM;EAAA;IACE,qBAAA;EAAN;AACF;AA3DA;EA+DM,mBAAA;AADN;AA9DA;EAoEI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,oCAAA;EACA,8BAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;AAMI;EAAA;IACE,UAAA;IACA,aAAA;IACA,8BAAA;EAHJ;EAKI;IACE,uBAAA;EAHN;EAEI;IAII,WAAA;EAHR;AACF;AAOI;EAAA;IACE,iBAAA;IACA,oBAAA;EAJJ;EAMI;IAEI,kBAAA;IACA,mBAAA;EALR;EAOQ;IACE,eAAA;IACA,gBAAA;EALV;EANE;IAiBI,kBAAA;IACA,6BAAA;EARN;AACF;AA7GA;EA0HI,oBAAA;AAVJ","sourcesContent":[".gyra-drawer {\n  .gyra-drawer-body {\n    padding: 2rem 5rem;\n    padding-right: 0rem;\n    height: 100%;\n    overflow-y: hidden;\n\n    .close-button {\n      .close-icon {\n        margin-right: 0.5rem;\n      }\n    }\n\n    @media (max-width: @md-screen) {\n      padding: 1rem;\n      padding-right: 0rem;\n    }\n  }\n\n  .gyra-drawer-content {\n    height: 100%;\n    padding-right: 5rem;\n    padding-bottom: 8.75rem;\n\n    &.no-footer {\n      padding-bottom: 2.5rem;\n    }\n\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    @media (max-width: @md-screen) {\n      padding-right: 1rem;\n    }\n\n    .divider,\n    hr {\n      opacity: 1;\n      border-top: 0.063rem solid #c9d3cc;\n      margin-top: calc(3.5rem - 2rem);\n\n      &:not(.success-divider) {\n        margin-bottom: 3.5rem;\n\n        @media (max-width: @md-screen) {\n          margin-bottom: 1.5rem;\n        }\n      }\n\n      @media (max-width: @md-screen) {\n        margin: 0rem 0rem 1.5rem 0rem;\n      }\n    }\n\n    .ant-form-item {\n      margin-bottom: 2rem;\n\n      @media (max-width: @md-screen) {\n        margin-bottom: 1.5rem;\n      }\n    }\n\n    .gyramais-alert {\n      margin-bottom: 2rem;\n    }\n  }\n\n  .gyra-drawer-footer {\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    border-top: 0.063rem solid #00000025;\n    justify-content: space-between;\n    padding: 1.25rem 3.5rem;\n    opacity: 1;\n    z-index: 3;\n    background-color: #ffffff;\n\n    &.no-back-btn {\n      justify-content: flex-end;\n    }\n\n    @media (max-width: @md-screen) {\n      z-index: 1;\n      padding: 1rem;\n      justify-content: space-between;\n\n      &.no-back-btn {\n        justify-content: center;\n\n        .gyramais-btn {\n          width: 100%;\n        }\n      }\n    }\n\n    @media (max-width: @md-screen) {\n      padding-top: 1rem;\n      padding-bottom: 1rem;\n\n      &:not(.no-back-btn) {\n        .gyramais-btn {\n          padding-left: 1rem;\n          padding-right: 1rem;\n\n          &.back-button {\n            padding-left: 0;\n            padding-right: 0;\n          }\n        }\n      }\n\n      .gyramais-btn-link {\n        padding-left: 0rem;\n        width: fit-content !important;\n      }\n    }\n  }\n\n  .gyra-drawer-title {\n    padding: 2.5rem 0rem;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
